import Vue from 'vue'
import Notifications from 'vue-notification'
import { showNotification } from '~/modules/vue-notifications/notifications-helper.js'

Vue.use(Notifications, { componentName: 'Notifications' })

export default (context, inject) => {
  inject('notify', showNotification)
}
